module.exports = __webpack_public_path__ + "static/media/sergo-park-coventry-gateway.7fc098a9.jpg";